import { clearSessionToken } from "./sessionCookie";

export const buildPortalLoginUrl = (returnTo?: string): string => {
  const loginUrl = `${process.env.NEXT_PUBLIC_PORTAIL_URL}/auth`;
  if (!returnTo) return loginUrl;

  return `${loginUrl}?from=${encodeURIComponent(returnTo)}`;
};

export const redirectToPortalLogin = (): void => {
  clearSessionToken();

  if (typeof window === "undefined") return;

  window.location.replace(buildPortalLoginUrl(window.location.href));
};
